<script lang="ts">
  interface Props {
    csrfToken: string;
  }

  let { csrfToken = "" }: Props = $props();

  let email = $state("");
  let loading = $state(false);
  let errorMessage = $state("");
  let sent = $state(false);

  async function handleSubmit(e: SubmitEvent) {
    e.preventDefault();
    loading = true;
    errorMessage = "";

    try {
      const formData = new FormData();
      formData.append("user[email]", email);
      formData.append("authenticity_token", csrfToken);

      const response = await fetch("/confirmation", {
        method: "POST",
        credentials: "same-origin",
        body: formData,
      });

      if (response.ok || response.redirected) {
        sent = true;
      } else if (response.status === 422) {
        errorMessage = "Please check the email address and try again.";
      } else {
        errorMessage = "We could not send a confirmation email right now. Please try again.";
      }
    } catch (error) {
      console.error("Resend confirmation error:", error);
      errorMessage = "We could not send a confirmation email right now. Please try again.";
    } finally {
      loading = false;
    }
  }
</script>

<div class="space-y-6">
  <div class="text-center">
    <h1 class="text-4xl font-bold text-foreground">Resend confirmation</h1>
    <p class="mt-2 text-base text-muted-foreground">Enter your email and we'll resend your confirmation link.</p>
  </div>

  {#if sent}
    <div class="rounded-md border border-primary/20 bg-primary/10 p-4">
      <p class="text-base text-primary">
        If that email exists and is unconfirmed, we sent a new confirmation link.
      </p>
    </div>

    <p class="text-center text-base text-muted-foreground">
      <a href="/login" class="font-medium text-primary hover:text-primary/80">
        Back to sign in
      </a>
    </p>
  {:else}
    {#if errorMessage}
      <div class="rounded-md border border-destructive/20 bg-destructive/10 p-4">
        <p class="text-base text-destructive">{errorMessage}</p>
      </div>
    {/if}

    <form onsubmit={handleSubmit} class="space-y-4">
      <div>
        <label for="email" class="block text-base font-medium text-foreground">Email address</label>
        <input
          id="email"
          type="email"
          placeholder="you@example.com"
          bind:value={email}
          required
          disabled={loading}
          class="mt-1 w-full rounded-md border border-border bg-background px-3 py-3 text-base shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:opacity-50"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        class="w-full rounded-md bg-primary px-4 py-3 text-base font-semibold text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:opacity-50"
      >
        {loading ? "Sending…" : "Resend confirmation email"}
      </button>
    </form>

    <p class="text-center text-base text-muted-foreground">
      <a href="/login" class="font-medium text-primary hover:text-primary/80">
        Back to sign in
      </a>
    </p>
  {/if}
</div>
